import { FETCH_PROG_AVAIL, FETCH_PROG_AVAIL_IS_LOADING, FETCH_PROG_AVAIL_HAS_ERRORED } from '../actions/types';

export function fetchProgAvail(state = [], action) {
	switch (action.type) {
		case FETCH_PROG_AVAIL:
			if (action.payload && action.payload === 'reset') {
				return [];
			}
			else if (action.payload && action.payload !== 0) {
				return [...state, action.payload];
			} else {
				return state;
			}
		default:
			return state;
	}
}
export function fetchProgAvailHasErrored(state = false, action) {
	switch (action.type) {
		case FETCH_PROG_AVAIL_HAS_ERRORED:
			return action.payload;
		default:
			return state;
	}
}
export function fetchProgAvailIsLoading(state = false, action) {
	switch (action.type) {
		case FETCH_PROG_AVAIL_IS_LOADING:
			return action.payload;
		default:
			return state;
	}
}
